export default {"src":"/_next/static/media/Clock.c6b90b24.svg","height":25,"width":25};